import { render } from "./how-it-works.vue?vue&type=template&id=b3ab8874&lang=pug"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__